<template>
  <div class="settings-wrp" :key="$route.path">
    <div class="settings-title">
      {{ t('General') }}
    </div>
    <div class="settings-content settings-columns-wrp">
      <div class="settings-column">
        <profile-form />
        <redirect-form v-if="canAccessPage('profile.general:redirect')" />
      </div>
      <div class="settings-column">
        <reporting-form />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n, useAcl } from '@/composables';
import ProfileForm from './forms/profile.vue';
import ReportingForm from './forms/reporting.vue';
import RedirectForm from './forms/redirect.vue';

const { t } = useI18n();
const { canAccessPage } = useAcl();
</script>

<style lang="scss" scoped>
</style>
